/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : authReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Narender - narender@au79consulting.com
 * @date 13-06-2024
 * @description Reducer function for handling authentication-related actions and state changes.
 */

import actionType from "../actionTypes";

const initialState = {
  isAuthenticated:
    localStorage.getItem("token") || sessionStorage.getItem("token")
      ? true
      : false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.LOGIN:
      return {
        ...state,
        isAuthenticated: true,
      };
    case actionType.FORGOT_PASSWORD:
      return {
        ...state,
      };
    case actionType.RESET_PASSWORD:
      return {
        ...state,
      };
    case actionType.SIGN_OUT:
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      return {
        ...state,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default authReducer;
